<template>
    <template v-if="breadcrumbs.length">
        <ol class="breadcrumb">
            <li v-for="(item, index) in breadcrumbs"
                :key="index"
                class="breadcrumb-item type-link"
                :class="{ 'active': index === last }">

                <NuxtLink v-if="index !== last"
                          :to="item.href">
                    <span v-html="item.text"></span>
                </NuxtLink>
                <span v-else-if="!h1"
                      v-html="item.text">
                </span>
            </li>
        </ol>
        <div v-if="h1" class="w-100 mb-3">
            <h1 class="h1-sm mb-0"
                v-html="breadcrumbs[last].text">
            </h1>
        </div>
    </template>
</template>

<script setup>
import { useBreadcrumbStore } from "~/stores/BreadcrumbStore";
import { computed } from 'vue';

const breadcrumbStore = useBreadcrumbStore();
const breadcrumbs = computed(() => breadcrumbStore.items || []);
const last = computed(() => breadcrumbs.value.length > 0 ? breadcrumbs.value.length - 1 : 0);

const props = defineProps({
    h1: Boolean,
});
</script>
